import { render, staticRenderFns } from "./StartupCostsTabs.vue?vue&type=template&id=7de3d5cd&scoped=true"
import script from "./StartupCostsTabs.vue?vue&type=script&lang=js"
export * from "./StartupCostsTabs.vue?vue&type=script&lang=js"
import style0 from "./StartupCostsTabs.vue?vue&type=style&index=0&id=7de3d5cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3d5cd",
  null
  
)

export default component.exports